var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"form__newsletter__icon__svg",class:_vm.getClass(),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{attrs:{"d":"M20 2H0v16h20V2zm-2 4l-8 5-8-5V4l8 5 8-5v2z","stroke":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }